import { FC } from 'react'
import { Button } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'

import useUrls from '../services/useUrls'

import buttonStyles from '../styles/CustomButtons.module.less'

const BrowseProducts: FC = () => {
  const { urlT } = useUrls()
  const { t } = useTranslation('landing')

  return (
    <Link
      href={urlT('/products')}
      shallow
      data-testid="browse-products-link"
    >
      <Button
        appearance="primary"
        className={`margin-top-spacer-tripple ${buttonStyles['custom-button']} ${buttonStyles['button-primary']} ${buttonStyles['button-caret']}`}
      >
        {t('common:Browse products')}
      </Button>
    </Link>
  )
}

export default BrowseProducts
